import React from 'react';
import { ProductForm } from '../../../Products/form/ProductForm';
import { useUrlDataContext } from '../../lib/UrlDataContext';
import { useActionContext } from '../../lib/ActionContext';

export const NewProduct = () => {
  const { currentUrlData, queueMatch, isCurrentUrlBlocked } = useUrlDataContext();
  const { setView, setProductId } = useActionContext();

  return (
    <ProductForm
      categoryStyleguideTarget='url-data-bottom-pane'
      suggestions={{
        brandName: currentUrlData?.brandName,
        categoryId: currentUrlData?.bestCategoryMatch?.id,
        title: currentUrlData?.productName,
        images: currentUrlData?.allImageUrls
      }}
      domain={currentUrlData?.domain}
      pinCount={currentUrlData?.pinCount}
      onSave={({ product, userCreatedBrand, userCreatedProduct }) => {
        queueMatch({
          hashedUrlStem: currentUrlData.hashedUrlStem,
          productId: product.id,
          metadata: { userCreatedProduct, userCreatedBrand }
        });
      }}
      onBackClick={() => {
        currentUrlData.bestProductMatch?.id ? setView('best-match') : setView('search');
      }}
      onExistingProductSelected={productId => {
        setProductId(productId);
        setView('edit-product');
      }}
      showDescriptionFields={false}
      showMetaOptions={false}
      disabled={isCurrentUrlBlocked}
    />
  );
};
